import SecureLS from 'secure-ls';

export const ls = new SecureLS({encodingType: 'rc4'});